import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { CONNECTED } from '../../state/modules/connection/reducers';
import { IconPlug } from '../ui-kit/icons';
import moment from 'moment';

const ConnectionStatusBanner = styled.div`
  width: 100%;
  position: fixed;
  top: 80px;
  left: 0;
  z-index: 2000;
  color: white;
  text-align: center;
  border-radius: 5px;
  border-color: #f5c6cb;
`;

const StyledFatalConnectionStatus = styled.div`
  background-color: #ff6550;
  width: 80%;
  height: 520px;
  margin: 0 auto;
  min-width: 480px;
  font-size: 25px;
  padding: 16px;
  box-shadow: 1px 1px 199px 44px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 1px 1px 199px 44px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 1px 199px 44px rgba(0, 0, 0, 0.75);
`;

const StyledConnectionStatus = styled.div`
  background-color: #ff6550;
  width: 50%;
  min-width: 250px;
  margin: 0 auto;
  padding: 16px;
  font-size: 25px;
  box-shadow: 1px 5px 11px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 1px 5px 11px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 5px 11px 0px rgba(0, 0, 0, 0.75);
`;

const CRITICAL_TIME = 5 * 60 * 1000; // show critical warning after 5 minutes
const MINIMUM_TIME = 15 * 1000; // start showing warning after 15 seconds

const CriticalConnectionWarning = ({ since }) => (
  <ConnectionStatusBanner>
    <StyledFatalConnectionStatus>
      <IconPlug className="d-block fa-8x mt-4 mb-2" />
      {I18n.t('connection.errors.connection_lost')}
      <br />
      {I18n.t('connection.offline_since')} <strong>{since}</strong>
    </StyledFatalConnectionStatus>
  </ConnectionStatusBanner>
);

const ConnectionStatus = ({ status, disconnectedSince }) => {
  if (status === CONNECTED) return null;

  const elapsedTime = Date.now() - disconnectedSince;

  // don't warn for very short interruptions
  if (elapsedTime < MINIMUM_TIME) return null;

  const since = moment(disconnectedSince).fromNow();

  // If the dashboard has been offline for more than 5 minutes,
  // display a more prominent warning.
  if (elapsedTime > CRITICAL_TIME) {
    return <CriticalConnectionWarning since={since} />;
  }

  // Display a minor warning at the bottom of the screen
  return (
    <ConnectionStatusBanner>
      <StyledConnectionStatus>
        <IconPlug /> {I18n.t('connection.offline_since')} {since}
      </StyledConnectionStatus>
    </ConnectionStatusBanner>
  );
};

const mapStateToProps = state => ({
  ...state.connectionStatus,
  appTime: state.appTime // to force updates
});

export default connect(mapStateToProps)(ConnectionStatus);
